import {
  defineNuxtRouteMiddleware,
  navigateTo,
  useRouter,
  useAppConfig,
  useRequestEvent,
} from '#imports'

type HankoRedirects = {
  login: string
  success: string
  home: string
  followRedirect?: boolean
}

type HankoAppConfig = {
  hanko: {
    redirects: HankoRedirects
  }
}

export default defineNuxtRouteMiddleware(async to => {
  const redirects = (useAppConfig() as HankoAppConfig).hanko.redirects

  if (process.server) {
    const event = useRequestEvent()!

    if (!event.context.hanko?.sub && to.path !== redirects.login) {
      return navigateTo({ path: redirects.login, query: { redirect: encodeURI(to.fullPath) } })
    }
    return
  }

  const hanko = await useHankoClient()

  const session = await hanko.validateSession().catch(() => null)
  if (!session?.is_valid && to.path !== redirects.login) {
    return navigateTo({ path: redirects.login, query: { redirect: encodeURI(to.fullPath) } })
  }

  const removeHankoHook = hanko.onUserLoggedOut(() => {
    return navigateTo({ path: redirects.login, query: { redirect: encodeURI(to.fullPath) } })
  })
  const removeRouterHook = useRouter().beforeEach(() => {
    removeHankoHook()
    removeRouterHook()
  })
})
